export var DHAMEN_STATUS = {
  NEW: "New",
  REVISED: "Revised",
  ACCEPTED: "Accepted",
  DECLINED: "Declined",
  EXPIRED: "Expired",
  PENDING: "Pending",
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  FUNDED: "Funded",
  DECLINED_ACTION: "declinedAction",
  //not comming from api
  ACCEPTED_ACTION: "acceptedAction" //not comming from api
};
export var MIN_FINANCING_AMOUNT = 10000;
export var MIN_MONTHLY_INCOME = 3000;
export var MAX_SAUDI_FINANCING_AMOUNT = 100000;
export var MAX_NON_SAUDI_FINANCING_AMOUNT = 50000;